const AUTH_USER_ID_TOKEN = 'idToken';
const AUTH_X_INSTIL = 'dotOrgXAuth';
const GA_DEBUG_MODE = 'gaDebugMode';
const OWNER_ORG_ID_PUB = 'ownerOrgId';
const OWNER_ORG_NAME = 'ownerOrgName';
const OWNER_ORG_VIEWS = 'ownerOrgViews';
const USER_ID_PUB = 'userId';
const IS_SUPER_ADMIN = 'isSuperAdmin';
const USER_EMAIL = 'userEmail';
const RECENTLY_VIEWED_CONSTITUENTS = 'recentlyViewedConstituents';
const VISIT_STREAK_CHECK_IN = 'visitStreakCheckIn';
const CORRELATION_ID = 'correlationId';
const USER_VIEWS = 'views';
const FEATURE_FLAGS = 'featureFlags';
const USER_NAME_PUB = 'userName';
const IMPERSONATE_PREVIOUS_CONTEXT = 'dotOrgImpersonatePreviousContext';
const IMPERSONATE_PREVIOUS_ROLES = 'dotOrgImpersonationRoles';
const DISMISSED_INSTALL = 'dismissedInstall';

export {
  AUTH_USER_ID_TOKEN,
  AUTH_X_INSTIL,
  CORRELATION_ID,
  DISMISSED_INSTALL,
  GA_DEBUG_MODE,
  OWNER_ORG_ID_PUB,
  OWNER_ORG_NAME,
  OWNER_ORG_VIEWS,
  USER_ID_PUB,
  IS_SUPER_ADMIN,
  USER_EMAIL,
  RECENTLY_VIEWED_CONSTITUENTS,
  VISIT_STREAK_CHECK_IN,
  USER_VIEWS,
  FEATURE_FLAGS,
  USER_NAME_PUB,
  IMPERSONATE_PREVIOUS_CONTEXT,
  IMPERSONATE_PREVIOUS_ROLES,
};
